import { ApiError } from '../api/client';

/**
 * Текст отказа для экрана. Класс отказа решает клиент API (AD-A6); здесь — слова и
 * `requestId`, чтобы человек мог назвать запрос в логах сервера.
 */
export function describeFailure(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 403) {
      return 'У вас нет права на это действие.';
    }
    if (error.status === 404) {
      return 'Не найдено.';
    }
    return describeApiFailure(error);
  }
  return error instanceof Error ? error.message : 'Что-то пошло не так.';
}

/**
 * То, что говорят про отказ API все экраны одинаково: обрыв транспорта и всё остальное —
 * сообщением сервера с `requestId`. Коды, у которых на экране свои слова (403 здесь,
 * 401 и 429 у входа), решаются до вызова: эта функция — общий хвост, а не диспетчер.
 */
export function describeApiFailure(error: ApiError): string {
  if (error.code === 'NETWORK_ERROR') {
    return 'Сервер недоступен. Проверьте сеть и попробуйте снова.';
  }
  return `${error.message}${error.requestId ? ` (запрос ${error.requestId})` : ''}`;
}
